<template>
  <div>
    <v-card flat class="pa-3 mt-2">
      <v-toolbar dense dark color="primary">
        <v-toolbar-title
        ><h4 class="font-weight-light">{{ current_page }}</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-stepper v-model="e1" non-linear :key="is_reset">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">
              {{ step_one_title }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">
              {{ step_two_title }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3" :complete="e1 > 3"> CONFIRMATION</v-stepper-step>
            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-12" color="grey lighten-1">
                <step1
                  v-on:data="on_select_table"
                  v-on:job_order="on_job_order"
                ></step1>
              </v-card>
              <!--              <v-card-actions>-->
              <!--                <v-spacer></v-spacer>-->
              <!--                <v-btn-->
              <!--                  v-if="travel_order_no!='' && name_of_customer!='' && $router.currentRoute.name==='add-new-order-dine-in'"-->
              <!--                  color="primary"-->
              <!--                  @click="reserve_table()"-->
              <!--                >-->
              <!--                  Next-->
              <!--                </v-btn>-->
              <!--              </v-card-actions>-->
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-12" color="grey lighten-1">
                <step2
                  :key="menus_data.length>0"
                  :selected_table="selected_table"
                  v-on:data="on_adding_menu"
                  v-on:job_order="on_job_order"
                  :menus_order="menus_data"
                  :type_of_service="type_of_service"
                  :purpose="purpose"
                  :options_items="options_items"
                ></step2>
              </v-card>
              <v-card-actions>
                <v-btn color="warning" @click="delete_reserve_table(1)">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="menus_data.length > 0"
                  color="primary" @click="save_order_menu()">
                  Next
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12" color="grey lighten-1">
                <confirmation
                  :key="menus_data.length>0"
                  v-on:data="on_adding_menu"
                  :menus_data="menus_data"
                ></confirmation>
              </v-card>
              <v-card-actions>
                <!-- alert -->
                <v-col cols="12" v-show="alert">
                  <v-alert color="warning" text class="mb-0">
                    <div class="d-flex align-start">
                      <v-icon color="warning">
                        {{ icons.mdiAlertOutline }}
                      </v-icon>

                      <div class="ms-3">
                        <p class="text-base font-weight-medium mb-1">
                          {{ alert_message }}
                        </p>
                      </div>
                    </div>
                  </v-alert>
                </v-col>
                <v-btn color="warning"
                       @click="e1--">
                  Back
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="menus_data.length>0&&!saving"
                       @click="delete_reserve_table(0)">
                  Save & Print
                </v-btn>
                <v-progress-circular color="primary" indeterminate
                                     v-if="saving"></v-progress-circular>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {mdiAlertOutline, mdiCloudUploadOutline} from '@mdi/js'
import {mapGetters, mapActions} from 'vuex'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
import Step1 from '@/views/cashier_interface/order_transaction/components/Step1'
import Step2 from '@/views/cashier_interface/order_transaction/components/Step2'
import Confirmation from '@/views/cashier_interface/order_transaction/components/Confirmation'
import moment from "moment";

const initialState = () => {
  return {
    saving: false,
    alert: false,
    alert_message: '',

    step_one_title: 'SELECT TRAVEL ORDER',
    step_two_title: 'ORDER SECTION',

    is_reset: false,
    e1: 1,
    travel_order: '',
    travel_order_no: '',
    name_of_customer: '',
    type_of_service: '',
    purpose: '',
    order_reference_no: '',
    order_code: '',
    current_page: '',
    date_and_time: '',
    customer_address: '',
    customer_contact_no: '',
    selected_table: {},

    travel_order_items: [],
    menus_data: [],
    options_items: [],
  }
}
export default {
  components: {
    snackBarDialog,
    Step1,
    Step2,
    Confirmation,
  },
  setup() {
    return {
      confirmation_data: {},
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
    }
  },
  data() {
    return initialState()
  },
  watch: {
    e1: function () {
      if (this.e1 > 3) {
        this.reset()
      }
    },
  },
  mounted() {
    this.get_not_yet_done_table_order()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
    ...mapGetters('authentication', ['month_start', 'month_end', 'month_of', 'user_id', 'branch_id', 'branch', 'branch_contact_no', 'branch_address', 'company_name']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('table', ['register_table', 'get_table_not_yet_done_order', 'get_table_not_yet_done_order_not_yet_paid', 'delete_register_table']),
    ...mapActions('table_order', ['register_service_order_table', 'get_table_not_yet_done_and_have_order']),
    ...mapActions('menu_order', ['get_available_service','get_all_type_service']),
    get_not_yet_done_table_order() {
      switch (this.$router.currentRoute.name) {
        case 'new-order-dine-in':
          this.current_page = 'ORDER SECTION'
          this.get_table_not_yet_done_order({
            branch_id: this.branch_id,
          })
            .then(response => {
              if (Object.keys(response.data).length > 0) {
                this.on_select_table(response.data)
                this.e1 = 2
                this.get_not_yet_done_table_and_have_already_order()
              }
            })
            .catch(error => {
              console.log(error)
            })
          break
        case 'add-new-order-dine-in':
          this.current_page = 'ADDITIONAL SERVICE SECTION'
          break
      }
    },
    get_not_yet_done_table_and_have_already_order() {
      this.get_table_not_yet_done_and_have_order({
        branch_id: this.branch_id,
        travel_order_no: this.travel_order_no,
      })
        .then(response => {
          if (Object.keys(response.data).length > 0) {
            this.menus_data = response.data
            this.e1 = 3
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    reset() {
      this.is_reset = true
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        Object.assign(this.$data, initialState())
      }, 100)
    },
    on_select_table(value) {
      this.selected_table=value
      this.key++
      this.step_one_title = 'TO# ' + value.travel_order_no + ' ' + value.name_of_customer + ' - ' +'('+value.purpose+')'
      this.step_two_title = 'TO# ' + value.travel_order_no + ' ' + value.name_of_customer + ' - '+'('+value.purpose+')'
      if (value.customer) {
        this.travel_order_no = value.travel_order_no
        this.name_of_customer = value.name_of_customer
        this.customer_address = value.customer.address
        this.customer_contact_no = value.customer.contact_no
        this.type_of_service = value.type_of_service
        this.purpose = value.purpose
        if (this.e1 === 1) {
          this.get_table_not_yet_done_order_not_yet_paid({
            branch_id: this.branch_id,
            travel_order_no: value.travel_order_no,
          })
            .then(response => {
              if (Object.keys(response.data).length > 0) {
                this.on_select_table(response.data)
                this.e1 = 2
                this.get_not_yet_done_table_and_have_already_order()
                this.get_all_type_service()
                  .then(response => {
                    this.options_items = response.data
                  })
                  .catch(error => {
                    console.log(error)
                  })
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },
    on_adding_menu(value) {
      this.menus_data = value.menus_data
    },
    reserve_table() {
      this.register_table({
        travel_order_no: this.travel_order_no,
        name_of_customer: this.name_of_customer.toUpperCase(),
        type_of_service: this.type_of_service,
        purpose: this.purpose,
        branch_id: this.branch_id,
      })
        .then(response => {
          this.change_snackbar({
            show: true,
            color: response.status === 200 ? 'success' : 'error',
            text: response.data,
          })
          this.get_not_yet_done_table_order()
        })
        .catch(error => {
          console.log(error)
        })
    },
    reference_no_generator() {
      this.date_and_time = moment().format('YYYY-MM-DD HH:mm:ss')
      var number = '0123456789'
      var characters = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789'
      var charactersLength = characters.length
      var result = ''
      var code = ''
      for (var i = 1; i <= 6; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
        code += number.charAt(Math.floor(Math.random() * number.length))
      }
      this.order_reference_no = 'ACA-' + result
      this.order_code = code
    },
    async delete_reserve_table(value) {
      await this.reference_no_generator()
      this.delete_register_table({
        travel_order_no: this.travel_order_no,
        branch_id: this.branch_id,
        is_delete: value,
        reference_no: this.order_reference_no,
        code: this.order_code,
        date: this.date_and_time,
        cashier_id: this.user_id,
      })
        .then(response => {
          if (response.status === 201) {
            this.change_snackbar({
              show: true,
              color: 'success',
              text: 'PLEASE PRINT RECEIPT ALWAYS',
            })
            this.print_receipt(response.data.reference_no, response.data.code, response.data.name_of_customer, response.data.type_of_service,response.data.purpose, response.data.customer.address, response.data.customer.contact_no)
          } else {
            this.change_snackbar({
              show: true,
              color: response.status === 200 ? 'success' : 'error',
              text: response.data,
            })
            if (value === 0 && response.status === 200) {
              this.print_receipt(this.order_reference_no, this.order_code, this.name_of_customer, this.type_of_service, this.purpose, this.customer_address, this.customer_contact_no)
            } else {
              this.e1--
            }
          }
        })
        .catch(error => {
          console.log(error)
        })

    },
    save_order_menu() {
      this.register_service_order_table({
        travel_order_no: this.travel_order_no,
        branch_id: this.branch_id,
        type_of_service: this.type_of_service,
        purpose: this.purpose,
        service_data: JSON.stringify(this.menus_data),
      })
        .then(response => {
          this.change_snackbar({
            show: true,
            color: response.status === 200 ? 'success' : 'error',
            text: response.data,
          })
          this.get_not_yet_done_table_and_have_already_order()
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    date_format(value) {
      return moment(value)
    },
    async service_available(value) {
      try {
        const response = await this.get_available_service({
          type_of_service: value,
        });
        return response.data;
      } catch (error) {
        console.error(error);
        return []; // fallback on error
      }
    },
    async on_job_order(value) {
      var imgData = this.company_logo
      let data_array = []
      let data_array2 = []
      let data_array3 = []

      let cleaning_data_array = []
      let repairs_data_array = []
      let installation_data_array = []

      let maintenance_data_array = []
      let recharging_data_array = []
      let dismantling_data_array = []

      let relocation_data_array = []
      let sales_data_array = []
      let other_data_array = []

      let remarks_details = []
      let widths = [173.33, 173.33, 173.33]

      data_array.push([
        {text: 'Cleaning', alignment: 'left', style: 'tableHeader'},
        {text: 'Repairs', alignment: 'left', style: 'tableHeader'},
        {text: 'Installation', alignment: 'left', style: 'tableHeader'},
      ])
      data_array2.push([
        {text: 'Maintenance', alignment: 'left', style: 'tableHeader'},
        {text: 'Recharging Freon', alignment: 'left', style: 'tableHeader'},
        {text: 'Dismantling', alignment: 'left', style: 'tableHeader'},
      ])
      data_array3.push([
        {text: 'Relocation', alignment: 'left', style: 'tableHeader'},
        {text: 'Sales', alignment: 'left', style: 'tableHeader'},
        {text: 'Other Services', alignment: 'left', style: 'tableHeader'},
      ])
      const cleaning = await this.service_available('Cleaning');
      const repairs = await this.service_available('Repairs');
      const installation = await this.service_available('Installation');

      const maintenance = await this.service_available('Maintenance');
      const recharging = await this.service_available('Recharging Freon');
      const dismantling = await this.service_available('Dismantling');

      const relocation = await this.service_available('Relocation');
      const sales = await this.service_available('Sales');
      const other = await this.service_available('Other Services');

      if (cleaning.length===0){
        cleaning_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},])
      }
      if (repairs.length===0){
        repairs_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'}])
      }
      if (installation.length===0){
        installation_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'}])
      }
      if (maintenance.length===0){
        maintenance_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},])
      }
      if (recharging.length===0){
        recharging_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'}])
      }
      if (dismantling.length===0){
        dismantling_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'}])
      }
      if (relocation.length===0){
        relocation_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},])
      }
      if (sales.length===0){
        sales_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'}])
      }
      if (other.length===0){
        other_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'},{text: '', alignment: 'left', style: 'contents3'}])
      }

      for (const item of cleaning) {
        cleaning_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'},])
      }
      for (const item of repairs) {
        repairs_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'}])
      }
      for (const item of installation) {
        installation_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'}])
      }
      for (const item of maintenance) {
        maintenance_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'},])
      }
      for (const item of recharging) {
        recharging_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'}])
      }
      for (const item of dismantling) {
        dismantling_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'}])
      }
      for (const item of relocation) {
        relocation_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'},])
      }
      for (const item of sales) {
        sales_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'}])
      }
      for (const item of other) {
        other_data_array.push([{text: '', alignment: 'left', style: 'contents3'},{text: parseFloat(item.amount)===0?'':item.amount, alignment: 'left', style: 'contents3'},{text: item.service_name, alignment: 'left', style: 'contents3'}])
      }
      data_array.push([
        {
          table: {
            widths: [15,25,110],
            body: cleaning_data_array,
          },
        },
        {
          table: {
            widths: [15,25,110],
            body: repairs_data_array,
          },
        },
        {
          table: {
            widths: [15,25,110],
            body: installation_data_array,
          },
        },
      ])
      data_array2.push([
        {
          table: {
            widths: [15,25,110],
            body: maintenance_data_array,
          },
        },
        {
          table: {
            widths: [15,25,110],
            body: recharging_data_array,
          },
        },
        {
          table: {
            widths: [15,25,110],
            body: dismantling_data_array,
          },
        },
      ])
      data_array3.push([
        {
          table: {
            widths: [15,25,110],
            body: relocation_data_array,
          },
        },
        {
          table: {
            widths: [15,25,110],
            body: sales_data_array,
          },
        },
        {
          table: {
            widths: [15,25,110],
            body: other_data_array,
          },
        },
      ])

      remarks_details.push([
        {text: '\n\n\n\n\n\n\n\n\n', alignment: 'left', style: 'contents'},
      ])
      let contents = [
        {
          columns: [
            {image: imgData, width: 70, height: 60, style: 'logo'},
            {
              stack: [
                this.company_name,
                {text: this.branch_address, style: 'subheader'},
                {
                  text: '* CONTACT NO.: ' + this.branch_contact_no,
                  style: 'subheader'
                },
              ],
              style: 'header'
            },
          ]
        },
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: 'JOB ORDER', style: 'title'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: 'Branch: ' + this.branch, style: 'contents'},
        {text: 'JOB ORDER #: ' + value.travel_order_no, style: 'contents'},
        {text: 'PURPOSE: ' + value.purpose, style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: 'Customer: ' + value.customer.company_name, style: 'contents'},
        {text: 'Customer Address: ' + value.customer.address, style: 'contents'},
        {text: 'Customer Contact#: ' + value.customer.contact_no, style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: 'TYPE OF SERVICE REQUESTED', style: 'contents'},
        {
          table: {
            widths: widths,
            body: data_array,
          },
        },
        {
          table: {
            widths: widths,
            body: data_array2,
          },
        },
        {
          table: {
            widths: widths,
            body: data_array3,
          },
        },
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {
          text: 'Should you need further clarifications, please feel free to communicate with us at contact no ' + this.branch_contact_no + '. Thank you.',
          style: 'contents'
        },
        {text: '', style: 'contents'},
        {text: '', style: 'contents'},
        {text: 'REMARKS', style: 'contents'},
        {
          table: {
            widths: [520],
            body: remarks_details,
          },
        },
      ]

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        pageSize: {
          width: 612,
          height: 936,
        },
        pageOrientation: 'portrait',
        content: contents,
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 20]//[left, top, right, bottom]
          },
          subheader: {
            fontSize: 12
          },
          title: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0]//[left, top, right, bottom]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          },
          table_default: {
            fontSize: 12,
          },
          contents: {
            margin: [0, 2, 0, 2],
            fontSize: 12,
            alignment: 'left',
          },
          contents2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            alignment: 'left',
          },
          contents3: {
            margin: [0, 2, 0, 2],
            fontSize: 6,
            alignment: 'left',
          },
          number_contents: {
            margin: [0, 2, 0, 2],
            fontSize: 14,
            alignment: 'right',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open();
    },
    async print_receipt(ref, code, customer, order,purpose, customer_address, customer_contact_no) {
      var img_1 = this.company_logo
      var title_array = []
      var head_array = []
      var data_array = []
      var foot_array = []
      var witdss = [70, 41.5, 15, 41.5]
      var witdssTi = [192]
      title_array.push(
        [
          {image: img_1, width: 192, height: 90, style: 'logo'},
        ]
      )
      head_array.push(
        [
          {text: 'Branch: ' + this.branch, alignment: 'left'},
        ]
      )
      head_array.push(
        [
          {text: 'TRAVEL ORDER #: ' + this.travel_order_no, alignment: 'left',},
        ]
      )
      head_array.push(
        [
          {text: 'Name: ' + customer, alignment: 'left',},
        ]
      )
      head_array.push(
        [
          {text: 'Address: ' + customer_address, style: 'subheader'},
        ]
      )
      head_array.push(
        [
          {text: 'Contact#: ' + customer_contact_no, style: 'subheader'},
        ]
      )
      head_array.push(
        [
          {text: 'Service Type: ' + order, alignment: 'left',},
        ]
      )
      head_array.push(
        [
          {text: 'Purpose: ' + purpose, alignment: 'left',},
        ]
      )
      head_array.push(
        [
          {text: 'Ref No.: ' + ref, alignment: 'left',},
        ]
      )
      head_array.push(
        [
          {text: 'Code No.: ' + code, alignment: 'left',},
        ]
      )
      head_array.push(
        [
          {
            text: this.date_and_time,
            alignment: 'left'
          },
        ]
      )
      data_array.push(
        [
          {text: 'Service', alignment: 'left'},
          {text: 'Amt', alignment: 'left'},
          {text: 'Pcs', alignment: 'left'},
          {text: 'Total', alignment: 'left'},
        ]
      )
      var gtotal = 0
      this.menus_data.forEach(function (item) {
        var tot = (parseFloat(item.amount) * parseInt(item.quantity))
        gtotal += tot
        data_array.push([
            {text: item.service.service_name, alignment: 'left'},
            {text: item.amount, alignment: 'left'},
            {text: item.quantity, alignment: 'left'},
            {
              text: (tot / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left'
            },
          ]
        )
      })
      foot_array.push(
        [
          {text: 'ACA TECHNICIAN COPY', alignment: 'center', pageBreak: "after"},
        ]
      )

      var title_array2 = []
      var head_array2 = []
      var data_array2 = []
      var foot_array2 = []
      var witdss2 = [70, 41.5, 15, 41.5]
      var witdssTi2 = [192]
      var img_2 = this.company_logo
      title_array2.push(
        [
          {image: img_2, width: 192, height: 90, style: 'logo'},
        ]
      )
      head_array2.push(
        [
          {text: 'Branch: ' + this.branch, alignment: 'left'},
        ]
      )
      head_array2.push(
        [
          {text: 'TRAVEL ORDER #: ' + this.travel_order_no, alignment: 'left',},
        ]
      )
      head_array2.push(
        [
          {text: 'Name: ' + customer, alignment: 'left',},
        ]
      )
      head_array2.push(
        [
          {text: 'Address: ' + customer_address, style: 'subheader'},
        ]
      )
      head_array2.push(
        [
          {text: 'Contact#: ' + customer_contact_no, style: 'subheader'},
        ]
      )
      head_array2.push(
        [
          {text: 'Service Type: ' + order, alignment: 'left',},
        ]
      )
      head_array2.push(
        [
          {text: 'Purpose: ' + purpose, alignment: 'left',},
        ]
      )
      head_array2.push(
        [
          {text: 'Ref. No.: ' + ref, alignment: 'left',},
        ]
      )
      head_array2.push(
        [
          {text: 'Code No.: ' + code, alignment: 'left',},
        ]
      )
      head_array2.push(
        [
          {
            text: this.date_and_time,
            alignment: 'left'
          },
        ]
      )
      data_array2.push(
        [
          {text: 'Service', alignment: 'left'},
          {text: 'Amt', alignment: 'left'},
          {text: 'Pcs', alignment: 'left'},
          {text: 'Total', alignment: 'left'},
        ]
      )
      var gtotal2 = 0
      this.menus_data.forEach(function (item) {
        var tot = (parseFloat(item.amount) * parseInt(item.quantity))
        gtotal2 += tot
        data_array2.push(
          [
            {text: item.service.service_name, alignment: 'left'},
            {text: item.amount, alignment: 'left'},
            {text: item.quantity, alignment: 'left'},
            {
              text: (tot / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              alignment: 'left'
            },
          ]
        )
      })
      data_array2.push(
        [
          {text: 'GRAND TOTAL', alignment: 'left'},
          {text: '', alignment: 'left'},
          {text: '', alignment: 'left'},
          {
            text: (gtotal2 / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left'
          },
        ]
      )
      foot_array2.push(
        [
          {text: 'ACA OFFICE COPY', alignment: 'center'},
        ]
      )
      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs === undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageOrientation: 'portrait',
        pageMargins: 1,
        content: [
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 12,
            },
            table: {
              widths: witdssTi,
              body: title_array,
            },
            layout: {
              hLineWidth: function (i, node) {
                return (i == 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i == 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 10,
            },
            table: {
              widths: witdssTi,
              body: head_array,
            },
            layout: {
              hLineWidth: function (i, node) {
                return (i == 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i == 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 9,
            },
            table: {
              widths: witdss,
              body: data_array,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex % 2 == 0) ? '#bae8cc' : null;
              },
              hLineWidth: function (i, node) {
                return (i == 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i == 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 9,
            },
            table: {
              widths: witdssTi,
              body: foot_array,
            },
            layout: {
              hLineWidth: function (i, node) {
                return (i == 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i == 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
          ,
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 12,
            },
            table: {
              widths: witdssTi2,
              body: title_array2,
            },
            layout: {
              hLineWidth: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 10,
            },
            table: {
              widths: witdssTi2,
              body: head_array2,
            },
            layout: {
              hLineWidth: function (i, node) {
                return (i == 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i == 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 9,
            },
            table: {
              widths: witdss2,
              body: data_array2,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex % 2 == 0) ? '#bae8cc' : null;
              },
              hLineWidth: function (i, node) {
                return (i == 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i == 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
          {
            style: {
              margin: [0, 2, 0, 2],
              fontSize: 9,
            },
            table: {
              widths: witdssTi2,
              body: foot_array2,
            },
            layout: {
              hLineWidth: function (i, node) {
                return (i == 0 || i === node.table.body.length) ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return (i == 0 || i === node.table.widths.length) ? 1 : 0;
              },
            },
          },
        ],
        footer: {},
        styles: {
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 7,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 8,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 11,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      var win = window.open('', '', "width=1000,height=500");
      pdfMake.createPdf(docDefinition).print({}, win)
      this.reset()
      this.e1++
    },
  },
}
</script>
